import { useMutation } from '@tanstack/react-query';

import { Envelope, EnvelopeDraft } from '../../../../types';
import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { createSignatureDraft } from '../../requests/createSignatureDraft';

export const useCreateSignatureDraft = () => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation<
    EnvelopeDraft | undefined,
    Error,
    Envelope
  >({
    mutationFn: (envelope) =>
      createSignatureDraft(constructPost, envelope).then(
        (response) => response?.data,
      ),
    onError: () => handleError('Failed to create draft.'),
  });

  return { createSignatureDraft: mutateAsync, ...rest };
};
